import React from 'react';
import { Container } from 'react-bootstrap';
import { Router } from 'src/routes';
import styles from './styles.module.css';
export const App = () => (React.createElement(Container, { className: styles.content },
    React.createElement(Router, null)));
